export default{
    only_add: false,
    filterLayersByTitle(layers, text){
        if(text){
            layers = layers.filter(x=>x.title.toLowerCase().indexOf(text.toLowerCase()) != -1)
            if(this.only_add){
                return layers.filter(x=>x.options.show)
            } 
            return layers
        } else {
            return layers
        }
    },
    changeButtonStyle(button_element){
        button_element.innerHTML = (this.only_add) ? "Adicionadas" : "Todas" 
        $(button_element).toggleClass("activated")
    },
    setOnlyAdd(value){
        this.only_add = value
    },
    getOnlyAdd(){
        return this.only_add
    },
    toggleOnlyAdd(){
        this.only_add = !this.only_add
    }
}